import { render, staticRenderFns } from "./SocialSignInButtons.vue?vue&type=template&id=83d11868&scoped=true"
import script from "./SocialSignInButtons.vue?vue&type=script&lang=js"
export * from "./SocialSignInButtons.vue?vue&type=script&lang=js"
import style0 from "./SocialSignInButtons.vue?vue&type=style&index=0&id=83d11868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d11868",
  null
  
)

export default component.exports